import classNames from "classnames";
import React from "react";
import "./ToggleList.scss";
export default function ToggleList({ id, title, children, isOpen, setIdCategory, idCategory, line }) {
    return (React.createElement("div", { key: id, className: "rt-toggle-list" },
        React.createElement("a", { className: "rt-list-title", onClick: () => setIdCategory(id != idCategory ? id : -1) }, title),
        React.createElement("div", { className: classNames("rt-toggle-list-content", {
                "rt-visible": isOpen,
            }) },
            React.createElement("div", { onClick: () => setIdCategory(-1), className: "close-dialog" },
                React.createElement("span", null, "X")),
            React.createElement("div", { className: "title-desc" },
                React.createElement("p", { className: "line-title" }, line),
                React.createElement("p", { className: "line-subtitle" }, title)),
            children)));
}
